/**
 * @Description: 门店配送管理
 * @Author Jiang
 * @Date 2020/8/18 13:47
 */
import React, {Component} from "react";
import {Button, List, message, Select, Skeleton} from "antd";
import './index.less'
import {Map, Marker, Polygon} from "react-amap";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import NoticeEmitter from "../../../utils/NoticeUtil";
import {getShopInfo, getTemplateListShop} from "../../../constants/api";
import {removeToken} from "../../../utils/cookie";

import {COMMON_ROUTER} from "../../../constants";

// const count = 3;
// const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;

export default class DeliveryManage extends Component {
  constructor(props) {
    super(props);

    NoticeEmitter.addListener('SHOPID_KEY', (value) => {
      console.log('配送管理=====================================' + value)
      this.setState({shopId: value}, () => this.getDeliveryArea())
    })

    this.state = {
      initLoading: true,
      loading: false,
      addressGeo: [116.2317, 39.5427],
      deliverGeo: '',
      areas: [],

      platformType: null
    }
  }

  componentDidMount() {
    this.getTemplateId()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType');
    let shopId = storage.getItem('shopId');
    if (templateId) {
      this.setState({
        templateId: templateId,
        platformType: platformType,
        shopId: shopId
      }, () => {
        this.searchShop();
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  //查询门店列表，用于切换门店
  searchShop() {
    const _this = this;
    getTemplateListShop({
      id: this.state.templateId,
      searchStr: "",
      shopId: 0,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            shop: data.data,
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_GOODS_SEARCH_SHOP, {
    //   id: this.state.templateId,
    //   searchStr: "",
    //   shopId: 0,
    //   templateId: this.state.templateId
    // })
    //   .then(function (response) {
    //     let data = response.data;
    //     console.log(data)
    //     _this.setState({
    //       shop: data.data,
    //     });
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }

  //切换门店
  changeShop = value => {
    console.log(value)
    this.setState({shopId: value}, () => this.getDeliveryArea())
  };

  /**
   * @Description: 获取配送区域信息
   * @Author Jiang
   * @Date 2020/8/18 18:59
   */
  getDeliveryArea() {
    getShopInfo({
      id: this.state.shopId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let addressGeo = data.data.addressGeo
          if (addressGeo == null || addressGeo == '') {
          } else {
            addressGeo = addressGeo.split(',');
          }

          let deliverGeo = data.data.deliverGeo
          deliverGeo = JSON.parse(deliverGeo)
          console.log(deliverGeo)
          this.setState({
            addressGeo: addressGeo,
            deliverGeo: deliverGeo
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_DELIVERY_AREA, {
    //   id: this.state.shopId,
    // }).then(res => {
    //   console.log(res)
    //   if (res.status === 200) {
    //     let data = res.data;
    //     if (data.code === 0) {
    //       let addressGeo = data.data.addressGeo
    //       addressGeo = addressGeo.split(',');
    //       let deliverGeo = data.data.deliverGeo
    //       deliverGeo = JSON.parse(deliverGeo)
    //       console.log(deliverGeo)
    //       this.setState({
    //         addressGeo: addressGeo,
    //         deliverGeo: deliverGeo
    //       })
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }


  /**
   * @Description: 跳转到修改地图页面
   * @Author Jiang
   * @Date 2020/8/18 14:59
   */
  edit = (shopId) => {
    if (this.state.platformType == 4) {
      console.log('-----------饿了么--------------')
      this.props.history.push({
        pathname: COMMON_ROUTER + '/editArea',
        state: {
          shopId: shopId,
        }
      });
    } else if (this.state.platformType == 5) {
      console.log('-----------饿百--------------')
      this.props.history.push({
        pathname: COMMON_ROUTER + '/editAreaFlower',
        state: {
          shopId: shopId,
        }
      });
    }
  }

  getAreaColor = (index) => {
    switch (index) {
      case 0:
        return 'rgba(255,38,16,0.55)'
      case 1:
        return 'rgba(255,207,37,0.59)'
      case 2:
        return 'rgb(29,122,25,0.5)'
      case 3:
        return 'rgb(45,47,235,0.5)'
      case 4:
        return 'rgb(255,52,234,0.5)'
      case 5:
        return 'rgb(54,255,54,0.5)'
      case 6:
        return 'rgba(194,149,255,0.59)'
      case 7:
        return 'rgba(255,30,12,0.76)'
    }
  }


  render() {
    return (
      <div style={{backgroundColor: "#fff", width: "100%", paddingLeft: '20px', paddingTop: "20px"}}>
        <div className='select-shop'>
          {/*<Select defaultValue="请选择店"*/}
          {/*        style={{width: 220, marginRight: 50}}*/}
          {/*        bordered={true}*/}
          {/*        onChange={this.changeShop}>*/}
          {/*  /!*<Option value={0}>{'全部'}</Option>*!/*/}
          {/*  {this.state.shop && this.state.shop.map((item) => {*/}
          {/*    return <Option key={item.branchShopId} value={item.branchShopId}>{item.branchShopName}</Option>*/}
          {/*  })}*/}
          {/*</Select>*/}
        </div>
        <div className='delivery'>
          <div className='delivery-title'>
            配送范围
          </div>
          <div className='window'>
            <List
              style={{marginTop:'20px',borderWidth:0,height:'600px',}}
              itemLayout="horizontal"
              dataSource={this.state.deliverGeo.features}
              renderItem={(item, index) => (
                <List.Item>
                  <Skeleton avatar title={false} loading={item.loading} active>
                    <div className='panel-item'>
                      <div className='panel-item__title'>
                        <div>
                          <span className='area-color' style={{
                            border: "1px solid rgb(66, 127, 237)",
                            backgroundColor: this.getAreaColor(index)
                          }}></span>
                          <span data-v-788752f8="" className="panel-item__title--text">区域{index + 1}
              </span>
                        </div>
                       {/* <div>配送中</div>*/}
                      </div>
                      <div>
                        <div className='panel-item__label_container'>
                          <span className='panel-item__label'>起送价:</span>{item.properties.area_agent_fee}元
                        </div>
                        <div className='panel-item__label_container'>
                          <span className='panel-item__label'>配送费:</span>{item.properties.delivery_price}元
                        </div>
                        {/* <div className='panel-item__label_container'>
                            <span className='panel-item__label'>面积:</span>0元
                          </div>*/}
                        <div className='panel-item__label_container'>
                          <span
                            className='panel-item__label'>生效时间:</span>{item.properties.multiPeriod.times[0][0]}-{item.properties.multiPeriod.times[0][1]}
                        </div>
                       {/* <div className='panel-item__label_container'>
                          <span className='panel-item__label'>最大重量:</span>{item.properties.max_weight}
                        </div>*/}
                      </div>
                    </div>
                  </Skeleton>
                </List.Item>
              )}
            />
          </div>
          <div className='delivery-map-main'>
            <div>
              <Button style={{border: 0, color: '#1989FA', marginBottom: "20px"}}
                      onClick={this.edit.bind(this, this.state.shopId)}><EditOutlined/>修改</Button>
            </div>
            <Map zoom={11} amapkey={'e73ee0f829ee336137ca9eabdee6382e'}
                 center={this.state.addressGeo}>
              <Marker position={this.state.addressGeo}/>
              {
                this.state.platformType == 4 ?
                    this.state.deliverGeo.features && this.state.deliverGeo.features.map((item, index) => {
                      return <Polygon key={index} path={item.geometry.coordinates[0]}
                                      style={{fillColor: this.getAreaColor(index), strokeColor: this.getAreaColor(index)}}/>
                    })
                    :
                    this.state.deliverGeo && this.state.deliverGeo.map((item, index) => {
                      return <Polygon key={index} path={item.region[0]}
                                      style={{fillColor: this.getAreaColor(index), strokeColor: this.getAreaColor(index)}}/>
                    })
              }
              {/*{this.state.deliverGeo.features && this.state.deliverGeo.features.map((item, index) => {*/}
              {/*  return <Polygon key={index} path={item.geometry.coordinates[0]}*/}
              {/*                  style={{fillColor: this.getAreaColor(index), strokeColor: this.getAreaColor(index)}}/>*/}
              {/*})}*/}
            </Map>
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/shopmanage/deliverymanage/index.js